import { UseFormWatch } from "react-hook-form";
import { TCreateJSA } from "../types";

interface SummaryStepProps {
  watch: UseFormWatch<TCreateJSA>;
}

const SummaryStep = ({ watch }: SummaryStepProps) => {
  const formValues = watch();

  return (
    <div className="space-y-6 rounded-xl border border-neutral-200 bg-white p-8">
      <h2 className="text-lg font-Medium text-primary-500">JSA Summary</h2>

      <div className="space-y-4 text-sm">
        <div className="grid grid-cols-2 border-b pb-4">
          <span className="font-medium text-neutral-500">Title:</span>
          <span>{formValues.title || "-"}</span>
        </div>
        <div className="grid grid-cols-2 border-b pb-4">
          <span className="font-medium text-neutral-500">Location:</span>
          <span>{formValues.workLocation || "-"}</span>
        </div>
        <div className="grid grid-cols-2 border-b pb-4">
          <span className="font-medium text-neutral-500">Start Date:</span>
          <span>
            {formValues.plannedStartDate
              ? new Date(formValues.plannedStartDate).toLocaleDateString()
              : "-"}
          </span>
        </div>
      </div>

      <div className="bg-yellow-50 text-yellow-800 p-4 rounded-lg mt-4 text-sm">
        Please review all identified hazards and controls before submitting this
        Job Safety Analysis. Submission will route this document to the
        appropriate supervisors for approval if residual risk is high.
      </div>
    </div>
  );
};

export default SummaryStep;
